import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParam,
    asyncGetPqrReceptionChannelHistorical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { PQR_RECEPTION_CHANNEL } from '../../../../../routes/paths';

export const usePqrReceptionChannelDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idReceptionChannel } = useParams();
    const [loading, setLoading] = useState(false);
    const [pqrReceptionChannel, setPqrReceptionChannel] = useState<Param>();
    const [pqrReceptionChannelHistorical, setPqrReceptionChannelHistorical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idReceptionChannel)) {
            setLoading(true);
            asyncGetParam(idReceptionChannel)
                .then((pqrReceptionChannel: any) => {
                    if (!pqrReceptionChannel || !pqrReceptionChannel.items)
                        navigate(PQR_RECEPTION_CHANNEL);
                    setPqrReceptionChannel(pqrReceptionChannel?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idReceptionChannel]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrReceptionChannelHistorical(idReceptionChannel)
                .then((resp) => {
                    if (resp) setPqrReceptionChannelHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        pqrReceptionChannel,
        pqrReceptionChannelHistorical,
        showHistorical,
        setShowHistorical,
    };
};
